////////////////////////////
//CURRENCY
////////////////////////////
export const FETCH_CURRENCY = "FETCH_CURRENCY";
export const FETCH_CURRENCY_FAIL = "FETCH_CURRENCY_FAIL";
export const FETCH_DEVELOPMENT_CURRENCY = "FETCH_DEVELOPMENT_CURRENCY";


////////////////////////////
//PRODUCTS
////////////////////////////
export const SET_ALL_PRODUCTS = "SET_ALL_PRODUCTS";
export const SET_PRODUCT = "SET_PRODUCT";
export const SET_FILTERS = "SET_FILTERS";
export const SET_RESULTS = "SET_RESULTS";


////////////////////////////
//CURRENT BOOKING
////////////////////////////
export const SET_BOOKING_DETAILS = "SET_BOOKING_DETAILS";
export const DELETE_BOOKING_DETAILS = "DELETE_BOOKING_DETAILS";
export const BOOKING_DETAILS_LOADING = "BOOKING_DETAILS_LOADING";


////////////////////////////
//CAPACITY
////////////////////////////
export const SET_CAPACITY = "SET_CAPACITY";



////////////////////////////
//NETWORK CITIES
////////////////////////////
export const SET_CITIES = "SET_CITIES";
export const SET_NEXT_DESTINATIONS = "SET_NEXT_DESTINATIONS";
export const SET_CITIES_DEPARTURES = "SET_CITIES_DEPARTURES";


////////////////////////////
//CART
////////////////////////////
export const SET_DEPARTURE = "SET_DEPARTURE";
export const SET_ADVENTURE_DEPARTURE = "SET_ADVENTURE_DEPARTURE";
export const SET_TOURID = "SET_TOURID";
export const SET_TOURNAME = "SET_TOURNAME";
export const SET_PRICE = "SET_PRICES";
export const UPDATE_SECTOR_LOADING = "UPDATE_SECTOR_LOADING";
export const SET_PASSENGER = "SET_PASSENGER";


////////////////////////////
//NATIONALITY
////////////////////////////
export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_STATES = "SET_STATES";

////////////////////////////
//FORMS
////////////////////////////
export const SET_FORM_PAX_DETAILS_VALID = "SET_FORM_PAX_DETAILS_VALID";
export const SET_FORM_LEAD_PAX_DETAIS_VALID = "SET_FORM_LEAD_PAX_DETAIS_VALID";
export const SET_SIGNUP_PAX_FORM = "SET_SIGNUP_PAX_FORM";
export const SET_PAYMENT_FORM = "SET_PAYMENT_FORM";

////////////////////////////
//UTILS
////////////////////////////
export const SET_FOOTER_MODAL = 'SET_FOOTER_MODAL';
export const SET_SLIDING_PANEL = 'SET_SLIDING_PANEL';
export const SET_PROGRESS_MODAL = 'SET_PROGRESS_MODAL';
export const SET_DELETE_MODAL = 'SET_DELETE_MODAL';
export const SET_UNAUTH_MODAL = 'SET_UNAUTH_MODAL';
export const SET_NONREFUND_MODAL = 'SET_NONREFUND_MODAL';
export const SET_EXPIRED_MODAL = 'SET_EXPIRED_MODAL';
export const SET_LOCKIN_MODAL = 'SET_LOCKIN_MODAL';
export const SET_INCLUDE_MODAL = 'SET_INCLUDE_MODAL';
export const SET_PLANNER_MODAL = 'SET_PLANNER_MODAL';


////////////////////////////
//HOTELS
////////////////////////////
export const SET_SECTOR_HOTELS = 'SET_SECTOR_HOTELS';
export const SET_CITY_HOTELS = 'SET_CITY_HOTELS';
export const UPDATE_HOTEL_LOADING = "UPDATE_HOTEL_LOADING";
export const SET_HOTEL_META = 'SET_HOTEL_META';